/*
  BNH — Ana sayfa kategori vitrini.

  Ürünlerin hepsi sayfada; seçim yalnızca hangi kartların görüneceğini
  belirliyor. Katalog küçük olduğu için bu, koleksiyon sayfasına gidip
  gelmekten çok daha hızlı.

  Kartlar ait oldukları koleksiyon handle'larını data-nb-cats içinde
  boşlukla ayrılmış taşıyor.
*/
(function () {
  function define() {
    if (window.customElements && customElements.get('nb-shop-strip')) return;

    class NBShopStrip extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.bnh-shop__track');
        this.chips = Array.prototype.slice.call(this.querySelectorAll('.bnh-shop__chip'));
        this.items = Array.prototype.slice.call(this.querySelectorAll('.bnh-shop__item'));
        this.more = this.querySelector('.bnh-shop__more-link');
        this.reveal = this.querySelector('.bnh-shop__reveal');
        this.revealBtn = this.querySelector('.bnh-shop__reveal-btn');
        this.arrows = Array.prototype.slice.call(this.querySelectorAll('.bnh-shop__nav-arrow'));
        if (!this.chips.length || !this.items.length) return;

        this.allUrl = this.more ? this.more.getAttribute('data-all-url') : null;
        this.allText = this.more ? this.more.textContent.trim() : '';

        this.chips.forEach(function (chip) {
          chip.addEventListener('click', function () {
            this.select(chip.dataset.cat === this.current ? '' : chip.dataset.cat);
          }.bind(this));
        }.bind(this));

        this.arrows.forEach(function (a) {
          a.addEventListener('click', function () {
            this.track.scrollBy({
              left: this.track.clientWidth * 0.7 * parseInt(a.dataset.dir, 10),
              behavior: 'smooth'
            });
          }.bind(this));
        }.bind(this));

        if (this.revealBtn) {
          this.revealBtn.addEventListener('click', function () {
            this.expanded = true;
            this.applyCap();
          }.bind(this));
        }
        window.addEventListener('resize', this.applyCap.bind(this), { passive: true });

        this.track.addEventListener('scroll', this.updateArrows.bind(this), { passive: true });
        window.addEventListener('resize', this.updateArrows.bind(this), { passive: true });

        this.select('');
        this.updateArrows();
        this.applySort();
      }

      /* Kartları Shopify'ın gerçek sırasına göre diz. Mağazadaki
         koleksiyon ayarlarına dokunmuyoruz: sıra hafif bir görünüm
         şablonundan okunuyor (templates/collection.order.liquid).
         İstek başarısız olursa ızgara mevcut sırasında kalır. */
      applySort() {
        var mode = this.dataset.sort;
        if (!mode) return;

        var cacheKey = 'nb-order-' + mode;
        var cached = null;
        try { cached = sessionStorage.getItem(cacheKey); } catch (e) {}

        if (cached) {
          this.orderBy(cached.split(','));
          return;
        }

        fetch('/collections/all?sort_by=' + encodeURIComponent(mode) + '&view=order', {
          headers: { 'X-Requested-With': 'fetch' }
        })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (text) {
            if (!text) return;
            var list = text.trim();
            /* Şablon yoksa Shopify tam sayfa döndürür; onu yeme. */
            if (!list || list.indexOf('<') > -1 || list.length > 4000) return;
            try { sessionStorage.setItem(cacheKey, list); } catch (e) {}
            this.orderBy(list.split(','));
          }.bind(this))
          .catch(function () {});
      }

      orderBy(handles) {
        if (!handles || !handles.length) return;
        var rank = {};
        handles.forEach(function (h, i) { rank[h.trim()] = i; });

        this.items.forEach(function (li) {
          var r = rank[li.dataset.nbHandle];
          li.style.order = (r === undefined ? 9999 : r);
        });

        /* Ana sayfadaki diğer ürün ızgaraları da (En Çok Satanlar,
           El Çantaları, Aksesuarlar) aynı sıraya girsin; hepsi
           koleksiyonun elle dizilmiş sırasını kullanıyordu. */
        document.querySelectorAll('.template-index .product-grid.grid').forEach(function (grid) {
          grid.querySelectorAll('.grid__item').forEach(function (li) {
            var a = li.querySelector('a[href*="/products/"]');
            if (!a) return;
            var m = a.getAttribute('href').match(/\/products\/([^?#]+)/);
            if (!m) return;
            var r = rank[decodeURIComponent(m[1])];
            li.style.order = (r === undefined ? 9999 : r);
          });
        });

        /* Sıra değişti; "daha fazla" kesmesi baştan hesaplansın. */
        this.items.sort(function (a, b) {
          return (parseInt(a.style.order, 10) || 0) - (parseInt(b.style.order, 10) || 0);
        });
        this.applyCap();
      }

      select(cat) {
        this.current = cat || '';
        var needle = ',' + this.current + ',';

        this.items.forEach(function (li) {
          var show = !this.current ||
            (li.dataset.nbCats || '').indexOf(needle) > -1;
          li.classList.toggle('bnh-shop__item--hidden', !show);
        }.bind(this));

        var active = null;
        this.chips.forEach(function (chip) {
          var on = (chip.dataset.cat || '') === this.current;
          chip.classList.toggle('is-active', on);
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on) active = chip;
        }.bind(this));

        /* Kategoriye özel "tümünü gör" bağlantısı: müşteri isterse
           gerçek koleksiyon sayfasına geçebilsin (SEO için de gerekli). */
        if (this.more) {
          if (this.current && active && active.dataset.url) {
            this.more.setAttribute('href', active.dataset.url);
            this.more.textContent = (active.dataset.label || '') + ' — tümünü gör';
          } else {
            this.more.setAttribute('href', this.allUrl || '/collections/all');
            this.more.textContent = this.allText;
          }
        }

        this.expanded = false;
        this.applyCap();

        if (active && this.current) {
          active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      }

      /* Ana sayfa bir katalog sayfası değil: varsayılan olarak
         birkaç satır gösterip gerisini isteğe bırakıyoruz, yoksa
         güven bloğu ve alt bölümler çok aşağı kayıyor. */
      cols() {
        var w = window.innerWidth;
        if (w <= 749) return parseInt(this.dataset.colsMobile, 10) || 2;
        if (w <= 989) return 3;
        return parseInt(this.dataset.cols, 10) || 4;
      }

      applyCap() {
        var rows = parseInt(this.dataset.rows, 10) || 2;
        var cap = this.cols() * rows;

        var matching = this.items.filter(function (li) {
          return !li.classList.contains('bnh-shop__item--hidden');
        });

        var extra = matching.length - cap;
        var hide = !this.expanded && extra > 0;

        matching.forEach(function (li, i) {
          li.classList.toggle('bnh-shop__item--capped', hide && i >= cap);
        });

        if (this.reveal) {
          this.reveal.hidden = !hide;
          if (hide && this.revealBtn) {
            this.revealBtn.textContent = extra + ' ürün daha göster';
          }
        }
      }

      updateArrows() {
        if (!this.track) return;
        requestAnimationFrame(function () {
          var overflow = this.track.scrollWidth - this.track.clientWidth;
          var x = this.track.scrollLeft;
          var scrollable = overflow >= 8;
          var prev = this.querySelector('.bnh-shop__nav-arrow--prev');
          var next = this.querySelector('.bnh-shop__nav-arrow--next');
          if (prev) { prev.hidden = !scrollable; prev.disabled = x <= 4; }
          if (next) { next.hidden = !scrollable; next.disabled = x >= overflow - 4; }
        }.bind(this));
      }
    }

    customElements.define('nb-shop-strip', NBShopStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', define);
  } else {
    define();
  }
})();
